import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Navigator from "./Navigator";
import { ConfigProvider } from "antd";
import { antDTheme } from "./theme";
import { StyleProvider } from "@ant-design/cssinjs";
import Modal from "@Components/Modal/Modal";
import ApiClientProvider from "@Api/Client";

const App = () => {
  return (
    <StyleProvider layer>
      <ConfigProvider theme={antDTheme}>
        <ApiClientProvider>
          <BrowserRouter>
            <Navigator />
            <Modal />
          </BrowserRouter>
        </ApiClientProvider>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default App;
